import { toCommaNumber } from 'common/formatters';
const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const numberRegEx = /^(\d)(\d|\.+\d)*$/;
const intRegEx = /^(\d)*$/;
const requiredMsg = 'This field is required';

export const email = value =>
  value && !emailRegEx.test(value) ? 'Enter a valid email address' : undefined;

export const required = value => (value ? undefined : requiredMsg);
// used for Input, Datepicker, Select components to get required *
export const isRequired = validate =>
  validate &&
  validate.some(
    fn =>
      fn &&
      fn
        .toString()
        .indexOf(
          process.env.NODE_ENV === 'development' ? 'requiredMsg' : requiredMsg
        ) >= 0
  );

export const numberOnly = value => {
  return !value || (numberRegEx.test(value) && !isNaN(value))
    ? undefined
    : 'Please enter a valid number';
};

// Added a specific validator function in order to target a bug fix in Fields and not break functionality of "minValue()"
// being used in other areas of the application
export const minValueField = (value, min) =>
  `${value}` && Number(value) <= Number(min)
    ? `Must be greater than ${toCommaNumber(min)}`
    : undefined;
export const minValuePlanted = (value, min) =>
  `${value}` && Number(value) < Number(min)
    ? `You have '${toCommaNumber(
        min
      )}' acres planted on this field, try a higher number`
    : undefined;

export const minValue = (value, min) =>
  `${value}` && Number(value) < Number(min)
    ? `This field must be greater than ${toCommaNumber(min)}`
    : undefined;
export const maxValue = (value, max) =>
  `${value}` && Number(value) > Number(max)
    ? `This field must be smaller than ${toCommaNumber(max)}`
    : undefined;

export const minLength = min => value =>
  value && value.length < Number(min)
    ? `This field must be ${min} characters or more`
    : undefined;
export const maxLength = (value, max) =>
  value && value.length > Number(max)
    ? `This field must be ${max} characters or less`
    : undefined;

export const hasDigit = value =>
  value && !/\d/.test(value) ? 'Need at least 1 digit' : undefined;
export const hasCapital = value =>
  value && !/[A-Z]/.test(value) ? 'Need at least 1 capital letter' : undefined;
export const hasLower = value =>
  value && !/[a-z]/.test(value)
    ? 'Need at least 1 lower case letter'
    : undefined;

export const noSpace = value =>
  value && value.includes(' ') ? 'This field cannot include space.' : undefined;

export const oneOf = (value, list) =>
  value && !list.some(item => item === value)
    ? `Invalid value ${value}`
    : undefined;
export const notOneOf = (value, list) =>
  value && list.some(item => item === value)
    ? `${value} already exists`
    : undefined;

// for FE react-router & browser url confusion
export const noPercent = value =>
  value && /%/.test(value) ? 'This field cannot include %' : undefined;
// for BE graphQL (single quotes are fine)
export const noQuotes = value =>
  value && /"/.test(value)
    ? 'This field cannot include double quotes (")'
    : undefined;
export const intOnly = value => {
  return !value || (intRegEx.test(value) && !isNaN(value))
    ? undefined
    : 'This field can only include integer';
};



// WEBPACK FOOTER //
// ./src/common/form-validators/index.js